export default __webpack_public_path__ + "static/media/navbar-reports-orange.5f77c8b6.svg";